import React from 'react';
import styled from './styled.module.scss';

interface IBasicStoreIconProps {
  store: 'google' | 'apple';
  href?: string;
  target?: string;
}

const BasicStoreIcon: React.FC<IBasicStoreIconProps> = ({store, href, target}) => {
  return (
    <a className={styled.store_icon} data-store={store} href={href} target={target}/>
  );
};

export default BasicStoreIcon;